<template>
  <dialog-base
    v-bind:shows="shows"
    v-bind:ok-callback="okCallback"
    v-bind:finalize-callback="finalizeCallback"
  >
    <template v-slot:body>
      <v-card-title v-if="$_titleExists">{{ title }}</v-card-title>
      <v-card-text v-if="$_messageExists">{{ message }}</v-card-text>
    </template>
  </dialog-base>
</template>

<script>
import DialogBase from './DialogBase.vue';

export default {
  components: {
    DialogBase,
  },

  props: {
    shows:            { type: Boolean },
    okCallback:       { type: Function },
    finalizeCallback: { type: Function },
    title:            { type: String },
    message:          { type: String },
  },

  computed: {
    $_titleExists()   { return (this.title !== undefined) },
    $_messageExists() { return (this.message !== undefined) },
  },
}
</script>